import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import Login from './Pages/Login';
import BackendManager from './Pages/BackendManager';
import { FirebaseProvider } from './context/FirebaseContext';

function App() {
  return (
    <FirebaseProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin/backend" element={<BackendManager />} />
          <Route path="/admin" element={<BackendManager />} />
        </Routes>
      </Router>
    </FirebaseProvider>
  );
}

export default App;